module.exports = __webpack_public_path__ + "img/icon_wy18.4a7716a7.png";